const PHONE_CHAR_RX = /[\d#+*\-_\s]/;

export const phoneMask = (value: string) =>
  value
    .split('')
    .filter((c) => PHONE_CHAR_RX.test(c))
    .map(() => PHONE_CHAR_RX);
